// @ts-nocheck
import * as React from "react";
import { IconOffset } from "@toolkit/Framework/Types/Icon";

const DoubleChevronRight: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M10.536 12 5.94 7.4l.708-.708L11.957 12l-5.308 5.308-.708-.708 4.595-4.6Zm6.1 0L12.04 7.4l.708-.708L18.057 12l-5.308 5.308-.708-.708 4.595-4.6Z"
            />
        </svg>
        /* Store Custom Code - End */
    );
};

export const DoubleChevronRightOffset: IconOffset = {
    vertical: 25, // Store Custom Code
    horizontal: 25, // Store Custom Code
};

export default React.memo(DoubleChevronRight);
